import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import LockTokens from './pages/LockTokens';
import LockedTokens from './pages/LockedTokens';
import UnlockedTokens from './pages/UnlockedTokens';
import { WalletProvider } from './context/WalletContext';
import { AdminProvider } from './context/AdminContext';
import ErrorBoundary from './components/ErrorBoundary';
import { themeCustom } from './utils/themeUtils';
import PlatformFees from './pages/PlatformFees';

// Placeholder components for About, Docs, Contact
const About = () => (
  <div style={{ 
    padding: 32, 
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  }}>
    <h2>About Token Locker</h2>
    <p>Secure, decentralized token locking platform with advanced security features.</p>
  </div>
);

const Docs = () => (
  <div style={{ 
    padding: 32, 
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  }}>
    <h2>Documentation</h2>
    <p>Comprehensive guides and API documentation coming soon.</p>
  </div>
);

const Contact = () => (
  <div style={{ 
    padding: 32, 
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  }}>
    <h2>Contact Us</h2>
    <p>Get in touch with our support team.</p>
  </div>
);

function App() {
  return (
    <ThemeProvider theme={themeCustom}>
      <CssBaseline />
      <WalletProvider>
        <AdminProvider>
          <Router>
            <ErrorBoundary>
              <Navbar />
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/lock-tokens" element={<LockTokens />} />
              <Route path="/locked-tokens" element={<LockedTokens />} />
              <Route path="/unlocked-tokens" element={<UnlockedTokens />} />
              <Route path="/platform-fees" element={<PlatformFees />} />
              <Route path="/about" element={<About />} />
              <Route path="/docs" element={<Docs />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
            </ErrorBoundary>
          </Router>
        </AdminProvider>
      </WalletProvider>
    </ThemeProvider>
  );
}

export default App; 